module.exports = __webpack_public_path__ + "img/logo_text_white.e1b44715.png";